<template>
    <section class="timeAxis">
        <div class="control">
            <span
                v-show="isPlaying == false"
                @click="handleClickPlay"
                color="#030305"
                :size="20"
                class="f"
            >
                <span class="x_icon"></span>
            </span>
            <span
                v-show="isPlaying == true"
                @click="handleClickPause"
                color="#030305"
                :size="20"
            >
                <i class="iconfont icon-audio-pause x">=</i>
            </span>
        </div>
        <div class="axis">
            <div class="miment" v-for="(item, index) in yearList" :key="index">
                <div class="time" @click="handleClickTime(item)">
                    <div class="icon"></div>
                    <div class="num">{{ item }}</div>
                </div>
            </div>
        </div>
        <div
            class="axis_active"
            :style="{
                width:
                    nowTime == 2011 ? '0px' : (nowTime - 2011) * 90 + 4 + 'px',
            }"
        >
            <div class="miment" v-for="(item, index) in yearList" :key="index">
                <div class="time" @click="handleClickTime(item)">
                    <div class="icon"></div>
                    <div class="num">{{ item }}</div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { EventBus } from "./utils/eventBus";
export default {
    data() {
        return {
            nowTime: 2011, //当前选中的年份 ( 从2012开始
            isPlaying: false,
            timer: null,
            yearList: [],
        };
    },
    watch: {
        $route() {
            clearInterval(this.timer);
            this.timer = null;
            this.nowTime = 2011;
            this.isPlaying = false;
        },
        nowTime() {
            console.log(this.nowTime);
        },
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
    methods: {
        handleClickTime(year) {
            clearInterval(this.timer);
            this.isPlaying = false;
            this.nowTime = year;
            EventBus.year = this.nowTime;
        },
        handleClickPlay() {
            this.isPlaying = true;

            if (this.nowTime > 2019) {
                clearInterval(this.timer);
                setTimeout(() => {
                    this.nowTime = 2011;
                    this.isPlaying = false;
                }, 3000);
            } else {
                this.nowTime += 1;
                EventBus.year = this.nowTime;
                this.play();
            }
        },
        play() {
            this.timer = setInterval(() => {
                if (this.nowTime > 2019) {
                    //播放后不手动停止一直循环
                    // clearInterval(this.timer);
                    setTimeout(() => {
                        this.nowTime = 2011;
                        this.isPlaying = false;
                        EventBus.year = 2019;
                    }, 2000);
                } else {
                    this.isPlaying = true;
                    this.nowTime++;
                    EventBus.year = this.nowTime;
                }
            }, 3000);
        },
        handleClickPause() {
            this.isPlaying = false;
            clearInterval(this.timer);
        },
    },
    created() {
        for (let i = 2012; i < 2020; i++) {
            this.yearList.push(i);
        }
    },
};
</script>

<style scoped lang="less">
.timeAxis {
    position: absolute;
    top: 0px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    .control {
        width: 26px;
        height: 26px;
        border-radius: 50%;
        background: #17D1FE;
        margin-right: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .miment {
        width: 90px;
        height: 8px;
        position: relative;
        &:first-child {
            border-radius: 4px;
        }
        &:last-child {
            border-radius: 4px;
        }
        .time {
            position: absolute;
            top: -5px;
            right: 0;
            z-index: 10;
            cursor: pointer;
            transform: translateX(50%);
            .icon {
                height: 18px;
                width: 8px;
                background: #37383c;
                border-radius: 4px;
                margin: 0 auto;
            }
            .num {
                height: 12px;
                line-height: 12px;
                text-align: center;
                margin-top: 4px;
                color: #9f9f9f;
            }
        }
    }
    .axis {
        background: #37383c;
        display: flex;
    }
    .axis_active {
        position: absolute;
        left: 36px;
        white-space: nowrap;
        transition: width 1s linear;
        overflow: hidden;
        .miment {
            width: 90px;
            height: 8px;
            position: relative;
            box-shadow: #17D1FE 0 0 7px inset, #17D1FE 0 0 7px;
            display: inline-block;
            border-top: 1px solid #17D1FE;
            border-bottom: 1px solid #17D1FE;
            &:first-child {
                border-radius: 4px;
                border-left: 1px solid #17D1FE;
            }
            &:last-child {
                border-radius: 4px;
                border-right: 1px solid #17D1FE;
            }

            .time {
                position: absolute;
                top: -5px;
                right: 0;
                z-index: 10;
                cursor: pointer;
                transform: translateX(50%);
                .icon {
                    height: 18px;
                    width: 8px;
                    background: #17D1FE;
                    border-radius: 4px;
                    margin: 0 auto;
                }
            }
        }
    }
}
.timeSelect {

    position: absolute;
    left: 0;
    top: 0;
}
.iconfont {
    pointer-events: auto;
    color: #fff
}
.icon {
    pointer-events: auto;
}
.f {
    position: relative;
}
.x_icon {
    position: absolute;
    left: -3px;
    top: -8px;
    display: inline-block;
    width: 0px;
    height: 0px;
    border-top: 8px transparent solid;
    border-left: 8px black solid ;
    border-bottom: 8px transparent solid;
    border-right: 8px transparent solid;
}
.x {
    color: black
}

</style>
